var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property, Collection } from '@syncfusion/ej2-base';
/**
 * Represents the field name and direction of a sort column in the TreeGrid.
 */
export class SortDescriptor extends ChildProperty {
}
__decorate([
    Property()
], SortDescriptor.prototype, "field", void 0);
__decorate([
    Property()
], SortDescriptor.prototype, "direction", void 0);
/**
 * Configures the sorting behavior of the TreeGrid.
 */
export class SortSettings extends ChildProperty {
}
__decorate([
    Collection([], SortDescriptor)
], SortSettings.prototype, "columns", void 0);
__decorate([
    Property(true)
], SortSettings.prototype, "allowUnsort", void 0);
